import React from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import EditIcon from "@mui/icons-material/Edit";
import { Delete } from "@mui/icons-material";
import { mkConfig, generateCsv, download } from "export-to-csv";
import ToastComponent from "./ToastComponent";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { FaFileExcel } from "react-icons/fa";
// ✅ CSV config
const csvConfig = mkConfig({
  fieldSeparator: ",",
  decimalSeparator: ".",
  useKeysAsHeaders: true,
});
import { useSelector } from "react-redux";
// ✅ Helper: Export specific fields to XLSX (no totals)
// const exportDataToXLSX = (data, fileName = "buy_success.xlsx", filteredData) => {
//   if (!data || data.length === 0) {
//     // alert("No data to export!");
//     return;
//   }

//   // ✅ STEP 1: Define only the fields you want to export
//   // const requiredFields = [
//   //   "orderId",
//   //   "customerName",
//   //   "orderAmount",
//   //   "status",
//   //   "createdAt",
//   // ];

//   // ✅ STEP 2: Map the data to include only those fields
//   // const filteredData = data.map((item) => {
//   //   const filteredItem = {};
//   //   requiredFields?.forEach((key) => {
//   //     filteredItem[key] = item[key] ?? ""; // handle missing keys gracefully
//   //   });
//   //   return filteredItem;
//   // });

//   // ✅ STEP 3: Convert to worksheet
//   const worksheet = XLSX.utils.json_to_sheet(filteredData);

//   // ✅ STEP 4: Create workbook and save
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

//   const excelBuffer = XLSX.write(workbook, {
//     bookType: "xlsx",
//     type: "array",
//   });

//   const blob = new Blob([excelBuffer], {
//     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//   });
//   saveAs(blob, fileName);
// };
const exportDataToXLSX = (data, fileName = "report.xlsx") => {
  if (!data?.length) return;

  const worksheet = XLSX.utils.json_to_sheet(data);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });

  const blob = new Blob([excelBuffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, fileName);
};

// ✅ Main Table Component
const CustomTable = ({
  columns,
  data,
  showRowAction = false,
  DataForExportAll,
  loading = false,
  date,
  permissionKey,
  filteredData,
}) => {
  // console.log("date: in column redeem", date);
  if (!data) data = [];
  if (!DataForExportAll) DataForExportAll = data;

  const handleExportRows = (rows) => {
    const rowData = rows.map((row) => row.original);
    const csv = generateCsv(csvConfig)(rowData);
    download(csvConfig)(csv);
  };

  // const handleExportData = () => {
  //   const csv = generateCsv(csvConfig)(DataForExportAll);
  //   download(csvConfig)(csv);
  // };

  //-------------logic for show export all data----------

  const rolePermissions = useSelector((state) => state.login.login.role);
  // console.log("[[[[[[[[[[[[]]]]]]]]]]]]]]]]]]]]]]]----rolepermision------",rolePermissions)
  const canExport = rolePermissions?.[permissionKey]?.export === 1;

  // console.log("=++++++++++",canExport)

  //-------------------$$----------------------------------

  //-----------handleexportdata------------------------
  const handleExportData = () => {
    // const visibleColumns = table
    //   .getVisibleLeafColumns()
    //   .filter(
    //     (col) =>
    //       col.id !== "mrt-row-select" &&
    //       col.id !== "mrt-row-actions"
    //   );
    const visibleColumns = table.getVisibleLeafColumns().filter((col) => {
      // Remove MRT internal columns
      if (col.id.startsWith("mrt-row-")) return false;

      // Remove Action column by header name
      if (col.columnDef.header === "Action") return false;

      return true;
    });

    const rowsToExport = table.getPrePaginationRowModel().flatRows;

    const exportData = rowsToExport.map((row) => {
      const obj = {};
      visibleColumns.forEach((col) => {
        obj[col.columnDef.header] = row.getValue(col.id);
      });
      return obj;
    });

    const csv = generateCsv(csvConfig)(exportData);
    download(csvConfig)(csv);
  };

  //----------------$$---------------------------------

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const table = useMaterialReactTable({
    columns,
    data,
    state: { isLoading: loading },
    initialState: { density: "compact" },
    enableRowSelection: true,
    columnFilterDisplayMode: "popover",
    paginationDisplayMode: "pages",
    positionToolbarAlertBanner: "bottom",
    enableRowActions: showRowAction,
    positionActionsColumn: "last",
    enableGlobalFilter: true,
    maxSize: 100,

    muiTableHeadCellProps: {
      sx: () => ({
        background: "#DCDAFF",
        fontWeight: "normal",
      }),
    },

    renderRowActions: ({ row }) => (
      <Box display="flex" flexDirection="row" alignItems="center">
        <Tooltip title="Edit User">
          <IconButton>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton>
            <Delete />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    renderTopToolbarCustomActions: ({ table }) => (
      <Box
        sx={{
          display: "flex",
          gap: "16px",
          padding: "8px",
          flexWrap: "wrap",
        }}
      >
        {/* Export All CSV */}
        {!isMobile && canExport && (
          <Button onClick={handleExportData} startIcon={<FileDownloadIcon />}>
            Export All Data
          </Button>
        )}

        {/* ✅ Export to XLSX */}
        {!isMobile && (
          <Button
            // startIcon={<FileDownloadIcon />}
            startIcon={<FaFileExcel />}
            // onClick={() => {
            //   console.log("---------------------->>>>",filteredData)
            //   const selectedRows = table
            //     .getSelectedRowModel()
            //     .rows.map((r) => r.original);
            //   const exportData =
            //     selectedRows.length > 0 ? selectedRows : DataForExportAll;
            //     console.log("========lucky==========",DataForExportAll)

            //   exportDataToXLSX(exportData, `redeem_success_${date}.xlsx`, filteredData);
            // }}
            //------------------------------------------------------
            // onClick={() => {
            //   const visibleColumns = table
            //     .getVisibleLeafColumns()
            //     .filter(
            //       (col) =>
            //         col.id !== "mrt-row-select" &&
            //         col.id !== "mrt-row-actions"
            //     );

            //   const selectedRows = table.getSelectedRowModel().flatRows;

            //   const rowsToExport =
            //     selectedRows.length > 0
            //       ? selectedRows
            //       : table.getPrePaginationRowModel().flatRows;

            //   const exportData = rowsToExport.map((row) => {
            //     const obj = {};
            //     visibleColumns.forEach((col) => {
            //       obj[col.columnDef.header] = row.getValue(col.id);
            //     });
            //     return obj;
            //   });

            //   exportDataToXLSX(exportData, `redeem_success_${date}.xlsx`);
            // }}
            //-----------------------------------------
            onClick={() => {
              const visibleColumns = table
                .getVisibleLeafColumns()
                .filter((col) => {
                  if (col.id.startsWith("mrt-row-")) return false;
                  if (col.id === "Action") return false;
                  if (col.columnDef.header === "Action") return false;
                  return true;
                });

              const selectedRows = table.getSelectedRowModel().flatRows;

              const rowsToExport =
                selectedRows.length > 0
                  ? selectedRows
                  : table.getPrePaginationRowModel().flatRows;

              const exportData = rowsToExport.map((row) => {
                const obj = {};
                visibleColumns.forEach((col) => {
                  obj[col.columnDef.header] = row.getValue(col.id);
                });
                return obj;
              });

              exportDataToXLSX(exportData, `redeem_success_${date}.xlsx`);
            }}
          >
            Download DSR
          </Button>
        )}
      </Box>
    ),
  });

  return (
    <>
      {/* */}
      <MaterialReactTable table={table} />
    </>
  );
};

export default CustomTable;
